import { render, staticRenderFns } from "./CTIDialogHistoryDetailTab.vue?vue&type=template&id=55d7c685&scoped=true"
import script from "./CTIDialogHistoryDetailTab.vue?vue&type=script&lang=js"
export * from "./CTIDialogHistoryDetailTab.vue?vue&type=script&lang=js"
import style0 from "./CTIDialogHistoryDetailTab.vue?vue&type=style&index=0&id=55d7c685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d7c685",
  null
  
)

export default component.exports